import { Schema } from 'effect';

/**
 * Whether the engine will price a configuration, as the engine names it.
 *
 * `complete` is a configuration every parameter of which has an answer, which the engine prices. `pending` is one with a parameter the engine has yet to settle — see `ParameterStateTypes` — which it does not: asked for a calculation, it would refuse, and the position would read as failed when it is only waiting on an
 * answer. Two words the UI acts on: the one decides whether a position is priced the moment its configuration lands, and the other what its row says meanwhile.
 *
 * Its own file for the reason `ParameterStateTypes` has one: a list the engine publishes and we copy, and a copy that is meant to fail when it drifts.
 */
export const ConfigurationStatusTypes = Schema.Literals(['complete', 'pending']);

/** Whether the engine will price a configuration. */
export type IConfigurationStatusType = typeof ConfigurationStatusTypes.Type;
